import { UserAuth } from '../generated/UserAuth';
export class AdminDTO {
  userAuth: UserAuth = new UserAuth();
  building_id = '';
  building_name = '';
}
